export { default } from './Promotion';
